// extracted by mini-css-extract-plugin
export var productImage = "_k6-1";
export var viewLink = "_k6-2";
export var wishlistItem = "_k6-0";